import assetPath from '/app/packages/lebenslauf/articles/src/assets/uberzeugender-einleitungssatz-so-ge.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')